import React, { Component } from "react";
import Header from "../home/Header";
import "./RestaurantsFoodTrucks.css";
import Footer from "../home/Footer";
class RestaurantsFoodTrucks extends Component {
  render() {
    return (
      <>
        <Header />
        <section
          id="more-services"
          className="more-services"
          style={{ padding: "60px 150px" }}
        >
          <div className="container">
            <div className="section-title ">
              <h2>“Your takeout order is ready!”</h2>

              <h6>Simplify customer contacts with text messaging.</h6>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul className="restaurantsProgressBar p-0">
                  <li className="active"></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 d-flex align-items-stretch">
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div
                    className="card-body"
                    style={{
                      background: "transparent",
                      boxShadow: "none",
                      textAlign: "center",
                    }}
                  >
                    <h5 className="card-title">ENTER THE CUSTOMER’S CELL #</h5>
                    <p>
                      Your staff member simply adds the customers name and
                      number into the simple dashboard.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex align-items-stretch">
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div
                    className="card-body"
                    style={{
                      background: "transparent",
                      boxShadow: "none",
                      textAlign: "center",
                    }}
                  >
                    <h5 className="card-title">TAP A BUTTON</h5>
                    <p>
                      With a tap of a button the customer receives a
                      personalized text with the pickup instructions that fit
                      your unique process (curbside or inside).
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex align-items-stretch">
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div
                    className="card-body"
                    style={{
                      background: "transparent",
                      boxShadow: "none",
                      textAlign: "center",
                    }}
                  >
                    <h5 className="card-title">PROMOTE YOUR BUSINESS</h5>
                    <p>
                      With a simply keyword like “PIZZA” or “JOIN”, your
                      customer can opt-in to receive ongoing text promotions set
                      up and sent by you.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "4em" }}>
              {" "}
              <div className="section-title ">
                <h2>Reach your customers with a single tap.</h2>
                <h6>
                  “If you want an easy way to communicate with your customer,
                  this system can’t be beat.”
                </h6>
              </div>
              <div className="row">
                <div
                  className="col-md-6 d-flex align-items-stretch"
                  style={{ textAlign: "center" }}
                >
                  <div
                    className="card"
                    // style={{
                    //   backgroundImage: "url(" + { moreServices } + ")",
                    // }}
                    data-aos="fade-up"
                    data-aos-delay={100}
                  >
                    <div className="card-body" id="restCard">
                      <div className="row">
                        <div className="col-md-3" style={{ margin: "auto" }}>
                          <i
                            className="fa icon fa-comments-o bordered round color8"
                            id="restIcon"
                          ></i>
                        </div>
                        <div className="col-md-9">
                          <h5 className="card-title">
                            A BETTER WAY TO COMMUNICATE
                          </h5>
                          <p>
                            There’s no better way to reach people these days
                            than by text message. GivBee’s restaurant solution
                            lets you leverage SMS for your inhouse and takeout
                            orders.
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 d-flex align-items-stretch"
                  style={{ textAlign: "center" }}
                >
                  <div
                    className="card"
                    // style={{
                    //   backgroundImage: "url(" + { moreServices } + ")",
                    // }}
                    data-aos="fade-up"
                    data-aos-delay={100}
                  >
                    <div className="card-body" id="restCard">
                      <div className="row">
                        <div className="col-md-3" style={{ margin: "auto" }}>
                          <i
                            className="fa icon fa-wrench bordered round color8"
                            id="restIcon"
                          ></i>
                        </div>
                        <div className="col-md-9">
                          <h5 className="card-title">
                            SIMPLE SETUP AND USER EXPERIENCE
                          </h5>
                          <p>
                            GivBee is a web-based solution that you can operate
                            from the web-connected tablet or PC that you already
                            own. It even works with voice-recognition — just
                            hook up a headset and insert customer orders in a
                            few simple words.
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 d-flex align-items-stretch mt-4"
                  style={{ textAlign: "center" }}
                >
                  <div
                    className="card"
                    // style={{
                    //   backgroundImage: "url(" + { moreServices } + ")",
                    // }}
                    data-aos="fade-up"
                    data-aos-delay={100}
                  >
                    <div className="card-body" id="restCard">
                      <div className="row">
                        <div className="col-md-3" style={{ margin: "auto" }}>
                          <i
                            className="fa icon fa-car bordered round color8"
                            id="restIcon"
                          ></i>
                        </div>
                        <div className="col-md-9">
                          <h5 className="card-title">
                            WORKS FOR DELIVERY ORDERS TOO
                          </h5>
                          <p>
                            Tired of paying 3rd party order apps 20%-30% on
                            every order? Use GivBee for delivery orders and your
                            delivery driver communications.
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 d-flex align-items-stretch mt-4"
                  style={{ textAlign: "center" }}
                >
                  <div
                    className="card"
                    // style={{
                    //   backgroundImage: "url(" + { moreServices } + ")",
                    // }}
                    data-aos="fade-up"
                    data-aos-delay={100}
                  >
                    <div className="card-body" id="restCard">
                      <div className="row">
                        <div className="col-md-3" style={{ margin: "auto" }}>
                          <i
                            className="fa icon fa-scissors bordered round color8"
                            id="restIcon"
                          ></i>
                        </div>
                        <div className="col-md-9">
                          <h5 className="card-title">TEXT-BASED MARKETING</h5>
                          <p>
                            Everybody loves a deal! Text coupons to your loyal
                            customers to drive more business. The list builds
                            itself as customers text your custom text keyword
                            from their phone.
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="container"
              style={{
                backgroundColor: "#85C1E9",
                padding: "4em",
                marginTop: "4em",
              }}
            >
              <div className="row">
                <div
                  className="col-lg-9 pt-4 pt-lg-0"
                  data-aos="fade-up"
                  data-aos-delay={300}
                  id="eventTextCol"
                >
                  <h2>Request a live demo today!</h2>
                </div>
                <div
                  className="col-lg-3"
                  data-aos="fade-up"
                  data-aos-delay={150}
                  style={{ textAlign: "end" }}
                >
                  <button
                    className="btn btn-primary"
                    style={{
                      background: "#fff",
                      color: "#fff",
                      border: "1px solid #fff",
                    }}
                  >
                    <a
                      href="/contactus"
                      className="btn-buy fw-bold"
                      style={{
                        color: "#fff",
                      }}
                    >
                      Request Demo
                    </a>
                  </button>
                </div>
              </div>
            </div>
            <section id="pricing" className="pricing ">
              <div className="container">
                <div className="section-title ">
                  <h2>Choose your plan</h2>

                  <h3>
                    <b>
                      If you’re not sure which plan will match your needs, we
                      can help. <a href="/contactus">Contact Us</a>.
                    </b>
                  </h3>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div
                      className="box "
                      data-aos="zoom-in-right"
                      data-aos-delay={200}
                    >
                      <h6>
                        <b>SMALL PLAN</b>
                      </h6>
                      <h4>
                        <sup>$</sup>39<span> / mo.</span>
                      </h4>
                      <p>
                        <b>Reduced from $55 for a limited time. </b>
                      </p>
                      <ul>
                        <li>800 SMS credits</li>
                        <li>Same-day setup</li>
                        <li>Free training & support</li>
                        <li> Overages – 6 cents per sms</li>
                      </ul>
                      <div className="btn-wrap">
                        <a href="/signup" className="btn-buy">
                          SIGN UP
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
                    <div
                      className="box recommended"
                      data-aos="zoom-in"
                      data-aos-delay={100}
                    >
                      <h6>
                        <b>BIG PLAN</b>
                      </h6>
                      <h4>
                        <sup>$</sup>59<span> / mo.</span>
                      </h4>
                      <p>
                        <b>Reduced from $90 for a limited time.</b>
                      </p>
                      <ul>
                        <li>1,600 SMS credits</li>
                        <li>Same-day setup</li>
                        <li>Free training & support</li>
                        <li> Overages – 5 cents per sms</li>
                      </ul>
                      <div className="btn-wrap">
                        <a href="/signup" className="btn-buy">
                          SIGN UP
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                    <div
                      className="box"
                      data-aos="zoom-in-left"
                      data-aos-delay={200}
                    >
                      <h6>
                        <b>ULTIMATE PLAN</b>
                      </h6>
                      <h4>
                        <sup>$</sup>99<span> / mo.</span>
                      </h4>
                      <p>
                        <b>Reduced from $160 for a limited time.</b>
                      </p>
                      <ul>
                        <li>4,000 SMS credits</li>
                        <li>Same-day setup</li>
                        <li>Free training & support</li>
                        <li> Overages – 4 cents per sms</li>
                      </ul>
                      <div className="btn-wrap">
                        <a href="/signup" className="btn-buy">
                          SIGN UP
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}

export default RestaurantsFoodTrucks;
